
import { reducerConstants } from "../../../constants/reducer-constant";
import { INITIAL_STATE as legacyLeadFormReducerInitialState, HANDLERS as legacyLeadFormReducerHandler } from "../../../components/desktop/legacy-form/reducers";

export default {
    [reducerConstants.LEGACY_LEAD_FORM]: { state: legacyLeadFormReducerInitialState, handler: legacyLeadFormReducerHandler }
};
